import ModalLink from 'components/ModalLink'
import { ActivationStatus, useActivationState } from 'connection/activate'
import { memo } from 'react'
import { useDispatch } from 'react-redux'
import { useModal } from 'store/app/hooks'
import { updateModal } from '../../store/app/actions/modalActions'
import { Failed } from './Failed'
import { EvmWalletSelection } from './EvmWalletSelection'
import { Stack, styled } from '@mui/material'
import { useWeb3Connecting } from '../../store/web3/hooks'
import { StarknetWalletSelection } from './StarknetWalletSelection'

import { ENABLE_STARKNET } from '../../config'

const WalletWrap = styled(Stack)`
  gap: 8px;
  padding: 8px 0;
`
export const WalletModal = memo(() => {
  const dispatch = useDispatch()
  const walletModal = useModal('wallets')
  const connecting = useWeb3Connecting()

  const { activationState } = useActivationState()
  const connectFailed = activationState.status === ActivationStatus.ERROR

  const header = connecting
    ? `Connecting`
    : connectFailed
      ? `Connect Failed`
      : `Connect a wallet`

  return (
    <ModalLink
      width="435px"
      isIn={walletModal}
      header={header}
      onClose={() => {
        dispatch(updateModal({ modal: 'wallets', open: false }))
      }}
    >
      <WalletWrap>
        {activationState.status === ActivationStatus.ERROR ? (
          <Failed />
        ) : (
          <>
            <EvmWalletSelection />
            {ENABLE_STARKNET && <StarknetWalletSelection />}
          </>
        )}
      </WalletWrap>
    </ModalLink>
  )
})
